import { lazy } from 'react';
import modules from '@src/service/modules';

// const StructureType = lazy(() => import('../../views/ProjectSetup/StructureType/index'));
const RoadType = lazy(() => import('../../views/Master/RoadType/index'));
const WorkCategory = lazy(() => import('../../views/ProjectSet/index'));
const ProjectOwner = lazy(() => import('../../views/ProjectOwner/index'));
const ProjectOwnerForm = lazy(() => import('../../views/ProjectOwner/component/Form'));
const AgencyView = lazy(() => import('../../views/Agency'));
const AgencyForm = lazy(() => import('../../views/Agency/component/Form'));

const ProjectSetupRoute = [
    {
        path: '/project-setup/road-type',
        element: <RoadType />
    },
    {
        path: '/project-setup/project-owner',
        element: <ProjectOwner />
    },
    {
        path: '/project-setup/project-owner/add',
        element: <ProjectOwnerForm />
    },
    {
        path: '/project-setup/project-owner/edit/:id',
        element: <ProjectOwnerForm />
    },
    {
        path: '/project-setup/agency',
        element: <AgencyView />
    },
    {
        path: '/project-setup/agency/add',
        element: <AgencyForm />
    },
    {
        path: '/project-setup/agency/edit/:id',
        element: <AgencyForm />
    },
    {
        path: '/project-setup/work-category',
        element: <WorkCategory />
    }
];

export default ProjectSetupRoute;
